export const manuscriptLabel = value =>
  ({
    human: 'Human-written',
    assisted: 'AI-assisted',
    generated: 'Contains AI-generated text',
  })[value] || 'AI use not yet declared';
export const feedbackLabel = value =>
  ({
    personal: 'Personal feedback',
    assisted: 'AI-assisted feedback',
    generated: 'AI-generated critique',
  })[value] || 'AI use not declared';
export const latestDisclosure = book =>
  book?.reader?.contentVersion?.aiDisclosure ||
  book?.aiDisclosure ||
  (Array.isArray(book?.content)
    ? [...book.content].reverse().find(v => v.parts?.length)?.aiDisclosure
    : book?.content?.aiDisclosure);
// Confirmation is per draft, never remembered or inferred from historical metadata.
export const getFeedbackPreference = () => 'undeclared';
